import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Toolbar,
  Typography,
  Checkbox,
  Link,
  LinearProgress,
  IconButton,
  TableHead,
  TableContainer,
  Paper,
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useHistory } from 'react-router-dom';
import xlsx from 'xlsx';
import './styles.scss';
// import moment from 'moment';

// Global Components
import KenLoader from '../../../Components/KenLoader/index';
import KenButton from '../../../global_components/KenButton';
import KenGrid from '../../../global_components/KenGrid';
import KenDialogBox from '../../../global_components/KenDialogBox';
import KenCheckbox from '../../../global_components/KenCheckbox/index';
import KenSnackbar from '../../../Components/KenSnackbar/index';
// ICOs
import PublishOutlinedIcon from '@material-ui/icons/PublishOutlined';
import { AiFillCheckCircle } from 'react-icons/ai';
import { FaFileDownload } from 'react-icons/fa';
// JSON
import {
  postValidateSession,
  postCreateSession,
} from '../../../Utils/apiServices';
import routes from '../../../Utils/routes.json';
import dayjs from '../../../Utils/dayjs';
import { useAppContext } from '../../../Utils/context';

const useStyles = makeStyles((theme) => ({
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
    margin: '10px 0px',
  },
  title: {
    fontWeight: 600,
    fontSize: '18px',
  },
  cancelBtn: {
    marginRight: '10px',
  },
  tableBox: {
    background: '#ffffff',
    padding: '10px 0px',
  },
  checkCircle: {
    width: '100%',
    height: '70px',
    color: '#36b37e',
  },
  error: {
    color: 'red',
  },
}));

export default function SessionPlanner(props) {
  const history = useHistory();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [pdfLoader, setPdfLoader] = useState(false);
  const [openUploadPage, setOpenUploadPage] = useState(false);
  const [showUploadform, setShowUploadform] = useState(false);
  const [uploadDialog, setUploadDialog] = useState(false);
  const [upload, setUpload] = useState(false);
  const [pdfLoaded, setPdfLoaded] = useState(0);
  const [filename, setFileName] = useState();
  const [correctUpload, setCorrectUpload] = useState(false);
  const [xlsxData, setXLSXData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [validationResponse, setValidationResponse] = useState([]);
  const inputFile = React.createRef();
  //   SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');

  const { config: { orgTimeZone = 'Asia/Kolkata' } = {} } = useAppContext();
  const column = [
    {
      Header: 'Type of Session',
      accessor: 'activityType',
      disableGlobalFilter: false,
    },
    {
      Header: 'Faculty Email',
      accessor: 'facultyEmail',
      disableGlobalFilter: false,
    },
    {
      Header: 'Start Date',
      accessor: 'startDate',
      disableGlobalFilter: false,
    },
    {
      Header: 'Start Time',
      accessor: 'startTime',
      disableGlobalFilter: false,
    },
    {
      Header: 'End Date',
      accessor: 'endDate',
      disableGlobalFilter: false,
    },
    {
      Header: 'End Time',
      accessor: 'endTime',
      disableGlobalFilter: false,
    },
    {
      Header: 'Facility Name',
      accessor: 'facilityName',
      disableGlobalFilter: false,
    },
    {
      Header: 'Faculty Name',
      accessor: 'facultyName',
      disableGlobalFilter: false,
    },
    {
      Header: 'Subject',
      accessor: 'courseName',
      disableGlobalFilter: false,
    },
    {
      Header: 'Term',
      accessor: 'termName',
      disableGlobalFilter: false,
    },
    {
      Header: 'Section',
      accessor: 'section',
      disableGlobalFilter: false,
    },
  ];
  const uploadSessionPlanner = () => {
    setUploadDialog(true);
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };
  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };
  const validateTemplate = (extractedData) => {
    setPdfLoader(true);
    let data = [];

    extractedData.map((item) => {
      data.push({
        courseName: item.Subject,
        sectionName: item.Section,
        sessionId: '',
        activityType: item['Type of Session'],
        startDate: convertDateTimeFormat(
          item['Start Date'],
          item['Start Time'],
          item['TimeZone']
        ),
        endDate: convertDateTimeFormat(
          item['End Date'],
          item['End Time'],
          item['TimeZone']
        ),
        facilityName: item['Facility Name'],
        facultyName: item['Faculty Name'],
        facultyEmail1: item['Faculty Email'],
        termName: item.Term,
      });
    });
    const payload = {
      Operation: 'Create',
      Session: data,
    };
    console.log('payload', payload);
    setTimeout(() => {
      setPdfLoaded(100);
    }, 1200);
    postValidateSession(payload)
      .then((res) => {
        let newData = [];

        if (res.Session[0].success ) {
          setValidationResponse(res.Session);
          let success = true;
          res.Session.forEach((item) => {
            if (!item?.message?.success) {
              success = false;
            }
            const endDate = dayjs(item.endDate.slice(0, -1))
              .tz(orgTimeZone, true)
              .local();
            const startDate = dayjs(item.startDate.slice(0, -1))
              .tz(orgTimeZone, true)
              .local();
            newData.push({
              ...item,
              endDateTime: endDate.format('DD/MM/YYYY'),
              endTime: endDate.format('hh:mm A'),
              // facultyName: item.facultyName,
              // facultyEmail: item.facultyEmail,
              // facilityName: item.facilityName,
              section: item.sectionName,
              startDateTime: startDate.format('DD/MM/YYYY'),
              startTime: startDate.format('hh:mm A'),
              // courseName: item.courseName,
              // activityType: item.activityType,
              // termName: item.termName,
              // message: item.message,
            });
            if (newData[0].success ==="true") {
              handleSnackbarOpen('success', item.message?.success);
              setCorrectUpload(true);
            } else {
              handleSnackbarOpen('error', 'Highlighted records are incorrect.');
            }
          });
          setXLSXData(newData);
          setPdfLoader(false);
          // setTimeout(() => {
          setUploadDialog(false);
          setPdfLoaded(0);
          setUpload(false);
          // }, 3000);
        }
      })
      .catch((err) => {
        console.log(err)
        setPdfLoader(false);
        setUploadDialog(false);
        handleSnackbarOpen('error', 'Please upload the correct template.');
        setUpload(false);
        setPdfLoaded(0);
      });
  };
  const submitProcessingTemplate = () => {
    setLoading(true);
    let data = [];
    validationResponse.map((item) => {
      data.push({
        courseOfferingId: item.courseOfferingId,
        sessionId: '',
        activityType: item.activityType,
        startDate: convertDateTimeUTC(item.startDate),
        endDate: convertDateTimeUTC(item.endDate),
        facilityId: item.facilityId,
        facultyId: item.facultyId,
      });
    });
    const payload = {
      Operation: 'Create',
      Session: data,
    };
    postCreateSession(payload)
      .then((res) => {
        console.log(res);
        handleSnackbarOpen('success', 'Data Updated Successfully');
        setLoading(false);
        history.push(routes.sessionScheduler);
      })
      .catch((err) => {
        setLoading(false);
        handleSnackbarOpen('error', 'Something went wrong! Try again.');
      });
  };
  const onButtonClick = () => {
    inputFile.current.click();
  };
  const convertDateTimeFormat = (date, time, timezone) => {
    const newTime = dayjs(time);

    console.log('282: ', date, time, timezone);

    return (
      dayjs(date)
        .add(10, 's')
        .set('h', newTime.get('h'))
        .set('m', newTime.get('m'))
        .tz(timezone, true)
        .utc()
        .tz(orgTimeZone)
        .format('YYYY-MM-DDTHH:mm:ss.000') + 'Z'
    );
  };

  const convertDateTimeUTC = (date) => {
    // const UTCFormat = new Date(date).toISOString();
    // return UTCFormat;
    // return dayjs(date).tz(orgTimeZone).format('YYYY-MM-DDTHH:mm:ss.000') + 'Z';
    return date;
  };
  // CONVERT XLSX TO JSON
  const convertXLSXtoJSON = (ev) => {
    setCorrectUpload(false);
    setPdfLoader(true);
    setTimeout(() => {
      setPdfLoaded(50);
    }, 1200);
    var files = ev.target.files,
      f = files[0];
    var reader = new FileReader();
    reader.onload = function (ev) {
      var data = ev.target.result;
      let readedData = xlsx.read(data, { type: 'binary', cellDates: true });
      const wsname = readedData.SheetNames[0];
      const ws = readedData.Sheets[wsname];
      /* Convert array to json*/
      const dataParse = xlsx.utils.sheet_to_json(ws);
      setOriginalData(dataParse);
      validateTemplate(dataParse);
    };
    reader.readAsBinaryString(f);
  };
  const fileSelected = (ev, i) => {
    console.log(ev.target.files);
    const file = ev.target.files[0];
    setUpload(true);
    setFileName(file.name);
    convertXLSXtoJSON(ev);
    setTimeout(() => {
      setPdfLoaded(20);
    }, 1000);
  };
  const handleUploadDialog = () => {
    setUploadDialog((prevState) => !prevState);
  };

  const handleDownloadTemplate = () => {
    window.open(
      'https://inazstgpfs3001.blob.core.windows.net/assets/sp-jain/admin/files/SessionPlanner-BulkTemplate.xlsx',
      '_blank'
    );
    handleSnackbarOpen('info', "A sample session has been added for you reference.")
  };
  return (
    <Box>
      {loading && <KenLoader />}
      {/* Header */}
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar style={{ minHeight: '45px', justifyContent: 'space-between' }}>
          <Typography variant="h6" className={classes.title}>
            Session Planner
          </Typography>
          {/* Buttons */}
          <Grid style={{ justifyContent: 'right', display: 'flex' }}>
            {/* {xlsxData.length > 0 ? (
              <KenButton
                label="Validate Upload"
                onClick={validateTemplate}
                variant="primary"
                style={{ marginRight: '10px' }}
                className={classes.SubmitBtn}
              />
            ) : null} */}
            <KenButton
              variant="primary"
              style={{ marginRight: 8, padding: 16 }}
              startIcon={<FaFileDownload />}
              onClick={handleDownloadTemplate}
            >
              Download Template
            </KenButton>

            <KenButton
              label="Upload Session Planner"
              onClick={uploadSessionPlanner}
              variant="primary"
              disable={xlsxData.length > 0 ? true : false}
              className={classes.refreshBtn}
              style={{ padding: '16px' }}
            />
          </Grid>
        </Toolbar>
      </AppBar>
      {/* Table */}
      <Box className={classes.tableBox}>
        <div className="session-planner-table">
          {/* <KenGrid
            columns={column}
            data={xlsxData}
            pagination={{ disabled: false }}
            toolbarDisabled={true}
          /> */}
          <Table>
            <TableHead>
              <TableRow>
                {column.map((item) => {
                  return <TableCell>{item.Header}</TableCell>;
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {xlsxData.length > 0 ? (
                xlsxData.map((data, index) => {
                  var message = Object.keys(data.message);
                  return (
                    <TableRow>
                      <TableCell
                        className={
                          message.includes('activityType')
                            ? classes.error
                            : null
                        }
                      >
                        {data.activityType}
                      </TableCell>
                      <TableCell
                        className={
                          message.includes('facultyEmail')
                            ? classes.error
                            : null
                        }
                      >
                        {data.facultyEmail}
                      </TableCell>
                      <TableCell
                        className={
                          message.includes('startDate') ? classes.error : null
                        }
                      >
                        {data.startDateTime}
                      </TableCell>
                      <TableCell
                        className={
                          message.includes('startTime') ? classes.error : null
                        }
                      >
                        {data.startTime}
                      </TableCell>
                      <TableCell
                        className={
                          message.includes('endDate') ? classes.error : null
                        }
                      >
                        {data.endDateTime}
                      </TableCell>
                      <TableCell
                        className={
                          message.includes('endTime') ? classes.error : null
                        }
                      >
                        {data.endTime}
                      </TableCell>
                      <TableCell
                        className={
                          message.includes('facilityName')
                            ? classes.error
                            : null
                        }
                      >
                        {data.facilityName}
                      </TableCell>
                      <TableCell
                        className={
                          message.includes('facultyName') ? classes.error : null
                        }
                      >
                        {data.facultyName}
                      </TableCell>
                      <TableCell
                        className={
                          message.includes('courseName') ? classes.error : null
                        }
                      >
                        {data.courseName}
                      </TableCell>
                      <TableCell
                        className={
                          message.includes('termName') ? classes.error : null
                        }
                      >
                        {data.termName}
                      </TableCell>
                      <TableCell
                        className={
                          message.includes('sectionName') ? classes.error : null
                        }
                      >
                        {data.section}
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell
                    colspan={11}
                    style={{
                      width: '100%',
                      textAlign: 'center',
                      fontWeight: 600,
                    }}
                  >
                    No Data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </Box>
      {correctUpload ? (
        <Grid xs={12}>
          <KenButton
            label="Submit"
            onClick={submitProcessingTemplate}
            variant="primary"
            className={classes.refreshBtn}
            style={{ float: 'right', marginTop: '10px', padding: '16px' }}
          />
        </Grid>
      ) : null}

      {/* Upload Dialog Box */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Upload Bulk Data
          </Typography>
        }
        open={uploadDialog}
        handleClose={() => handleUploadDialog()}
        negativeButtonClick={() => handleUploadDialog()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        hidePositiveButton={true}
        maxWidth="lg"
        dividers
      >
        <Grid container spacing={3}>
          <div className="invoice-page-wrapper">
            <div
              className="invoice-custom-table-wrapper"
              style={{ padding: '0px' }}
            >
              <div className="pdf-extract-wrap" style={{ height: '70%' }}>
                <div
                  className="onboard-card dot-card"
                  onClick={onButtonClick}
                  style={{
                    height: '70vh',
                    width: '100%',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    textAlign: 'center',
                  }}
                >
                  {upload ? (
                    <React.Fragment>
                      <div
                        className="file-upload-wrap"
                        style={{ width: '70%' }}
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                      >
                        {pdfLoaded != 100 ? (
                          <>
                            <span
                              className="file-loaded-percentage"
                              style={{ position: 'absolute', top: '8px' }}
                            >
                              {pdfLoaded}%
                            </span>
                            <p className="file-process-hd">
                              {' '}
                              Uploading File({filename}){' '}
                            </p>
                          </>
                        ) : (
                          <>
                            <span style={{ width: '80px' }}>
                              <AiFillCheckCircle
                                className={classes.checkCircle}
                              />
                            </span>
                            <p
                              className="file-process-hd"
                              style={{ justifyContent: 'center' }}
                            >
                              {' '}
                              Upload Complete
                            </p>
                          </>
                        )}

                        {pdfLoader && <CircularProgress />}
                      </div>
                    </React.Fragment>
                  ) : (
                    <div>
                      <input
                        type="file"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        id="file"
                        ref={inputFile}
                        style={{ display: 'none', cursor: 'pointer' }}
                        onChange={fileSelected}
                      />
                      <div className="card-third-round  ">
                        <PublishOutlinedIcon className="onboard-icons" />
                      </div>
                      <h6 className="onboard-card-header">Upload Excel</h6>
                      <p
                        className="onboard-card-title"
                        style={{ color: '#000' }}
                      >
                        Drag and drop file or{' '}
                        <span className="browse-content">browse</span>
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Grid>
      </KenDialogBox>
      {/* Alert */}
      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
    </Box>
  );
}
